const app = require('loginApp');
const route = require('shared/router/routeLogin');

const passwordResetController = require('app/passwordReset/passwordResetController');

const appRoutes = {
    'passwordReset/:resetKey': 'showPasswordReset'
};

const api = {
    'showPasswordReset': function(resetKey) {
        passwordResetController.show(app.getView().getRegion('mainRegion'), resetKey);
    }
};

route(appRoutes, api);